<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      List
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let item of items">
      <ion-icon [name]="item.icon" slot="start"></ion-icon>
      {{item.title}}
      <div class="item-note" slot="end">
        {{item.note}}
      </div>
    </ion-item>
  </ion-list>
  <!--
    <div *ngIf="selectedItem ion-padding">
      You navigated here from <b>{{selectedItem.title }}</b>
    </div>
  -->
</ion-content>
